'use strict';

var azureStorageBlob = 'AzureStorageBlob';
var azureStorageFile = 'AzureStorageFile';
var azureStorageOther = 'AzureStorageOther';
var awsStorageS3 = 'AwsStorageS3';
var awsStorageOther = 'AwsStorageOther';
var gcsStorageBucket = 'GcsStorageBucket';
var gcsStorageOther = 'GcsStorageOther';
var list = [azureStorageBlob, azureStorageFile, azureStorageOther, awsStorageS3, awsStorageOther, gcsStorageBucket, gcsStorageOther];
var awsList = [awsStorageS3, awsStorageOther];
var azureList = [azureStorageBlob, azureStorageFile, azureStorageOther];
var gcsList = [gcsStorageBucket, gcsStorageOther];

module.exports = {
    azureStorageBlob: azureStorageBlob,
    azureStorageFile: azureStorageFile,
    azureStorageOther: azureStorageOther,
    awsStorageS3: awsStorageS3,
    awsStorageOther: awsStorageOther,
    gcsStorageBucket: gcsStorageBucket,
    gcsStorageOther: gcsStorageOther,
    list: list,
    awsList: awsList,
    azureList: azureList,
    gcsList: gcsList
};